import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import client from "utils/clients/apollo"
import {ApolloProvider} from "@apollo/client"
import {Provider as FluentUIProvider, teamsTheme} from "@fluentui/react-northstar"

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <FluentUIProvider style={{height: "100%"}} theme={teamsTheme}>
        <App />
      </FluentUIProvider>
    </ApolloProvider>
  </React.StrictMode>, document.getElementById("root")
)
